import { ICategoryDetails } from "@/interfaces";
import { CategoryProductsSection } from "./CategoryProductsSection";
import { UpperContent } from "./UpperContent";
import { DynamicElementType } from "@/lib/constants";
import React from "react";
import { DynamicBanner } from "@/components/shared/dynamicBanner";
import { MarketPlaceLongBody } from "../marketplaceLongBody";
import { useGlobalContext } from "@/lib/context";


type props = {
    catProducts: ICategoryDetails
}
export function CategoryPage({ catProducts }: props) {
    const { props: { isAppView } } = useGlobalContext();
    return (<>
        {!isAppView && <UpperContent catName={catProducts.metaDetails.heading} shortContent={catProducts.metaDetails.short_content} />}
        {
            catProducts?.categories?.sort((a: any, b: any) => b.productCount - a.productCount)?.map((f, idx) => {
                const position = idx + 1;
                const data = catProducts.marketingBanner?.find((f) => f.position == position) || {} as any
                return (
                    <React.Fragment key={idx}>
                        <CategoryProductsSection products={f} isFirstCat={idx === 0} catSlug={catProducts.serviceSlug} backgroundColor="#fff" elementType={DynamicElementType.h3} />
                        {Object.keys(data).length > 0 && <DynamicBanner bannersData={data} />}
                    </React.Fragment>

                )
            })
        }
        <MarketPlaceLongBody metaDetails={catProducts.metaDetails} />
    </>
    )
}